import { defineMessages } from 'react-intl';

export default defineMessages({
	add: {
		id: 'pages.dashboard.add',
		defaultMessage: 'Add Assets',
	},
	addPaused: {
		id: 'pages.dashboard.addPaused',
		defaultMessage: 'Uploads are paused for this account. See the notice at the top of the page.',
	},
	saveSearch: {
		id: 'pages.dashboard.saveSearch',
		defaultMessage: 'Save this search',
	},
	searchInfo: {
		id: 'pages.dashboard.searchSetUp',
		defaultMessage:
		  "Please upload a image to enable filters",
	  },
	noDuplicates: {
		id: 'pages.dashboard.noDuplicates',
		defaultMessage: 'No duplicates found for this file.',
	},
	uploadsStillProcessing: {
		id: 'pages.dashboard.uploadsStillProcessing',
		defaultMessage:
		  'Some uploads are still being processed and may not match your current filters. Refresh or clear filters to see them.',
	  },
});
